import React from 'react';
import {About} from './container'
import { Header } from './container';
import { Work } from './container';
import { Skill } from './container';
import { Footer } from './container';
import { Navbar } from './components';
import'./App.scss';



const App = () => {
  return (
    <div className='app'>
      <Navbar/> 
       <Header />
       <About />
       <Work />
       <Skill/>
       {/* <Testimonial /> */}
       <Footer/>
    </div>
  );
}

export default App;